import { makeStyles } from '@material-ui/core'

export default makeStyles({ 
    paper: { 
        marginTop: 20
    }
});